export const HINT_TEXT = `Ты получаешь за правильный ответ 10
баллов. За неправильный ответ 1 балл.`;
